<template>
  <router-view />
</template>

<script setup>
import { onMounted } from "vue";
import { useStore } from "vuex";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const store = useStore();

const initFirebase = () => {
  const firebaseConfig = {
    apiKey: "AIzaSyCDMMWBZtD-N1zSEuzbUYzsllSFVWk6H14",
    authDomain: "alliance-crm-fe259.firebaseapp.com",
    projectId: "alliance-crm-fe259",
    storageBucket: "alliance-crm-fe259.appspot.com",
    messagingSenderId: "83440943839",
    appId: "1:83440943839:web:e1c825f876ced21f885f6a",
  };

  try {
    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    if (!("serviceWorker" in navigator)) {
      console.warn("Service workers are not supported");
      return;
    }

    navigator.serviceWorker.register("/firebase-messaging-sw.js");

    // Foreground messages
    onMessage(messaging, (payload) => {
      console.info("Message received:", payload);

      // Vuex action
      store.dispatch("getNotificationCount");

    });

    // Get FCM token
    getToken(messaging, {
      vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY,
    })
      .then((token) => {
        if (token) {
          localStorage.setItem("message_token", token);
        }
      })
      .catch((err) => {
        console.error("Token error:", err);
      });
  } catch (error) {
    console.error("Firebase initialization error:", error);
  }
};

onMounted(() => {
  initFirebase();
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align: center;

  nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
}
</style>
